import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DemoService } from './services/demo.service';
import { SidenavService } from './services/sidenav.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { onMainContentChange } from './animation';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [onMainContentChange],
})
export class AppComponent implements OnInit, OnDestroy {


  onSideNavChange2: boolean = false;

  @ViewChild('sidenav2', {static: false}) sidenav2: MatSidenav | undefined;

  private unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    public demoService: DemoService,
    private sidenavService: SidenavService,
    public router: Router) {

    this.sidenavService.sideNavState$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(res => {
        this.onSideNavChange2 = res;
        this.moveSidenav2();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(false);
    this.unsubscribeAll.complete();
  }

  ngOnInit() {
    this.demoService.getRequestDemoList()
      .subscribe((data) => {
        this.demoService.countDemoRequested$.next(data.length);
      });
  }

  moveSidenav2(): void {
    if (this.onSideNavChange2) {
      this.sidenav2?.open().then();
    } else {
      this.sidenav2?.close().then();
    }
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/main').then(success => {
      if (!success) {
        console.error('Navigation failed!');
      }
    });

  }

  openSentry() {
    window.open('https://kreditpro.sentry.io', '_blank');
  }

  openJenkins() {
    window.open('http://212.193.63.10:8080/', '_blank');
  }

  openPortainer() {
    window.open('https://kreditpro.org/portainer/', '_blank');
  }

  openGrafana() {
    window.open('https://kreditpro.org/grafana/', '_blank');
  }

  openProxyManager() {
    window.open('http://212.193.63.10:81/login', '_blank');
  }




}
